module.exports = __webpack_public_path__ + "static/media/icon-always-on.2f584cdf.svg";